<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <div style="position:relative!important;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          @click="
            () => {
              this['Sale/fetchSales']({ page: this.page });
              $router.push('/sale');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card class="elevation-0">
          <v-list>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Customer Name</v-list-item-title>
                <v-list-item-subtitle>{{ sale.customer_name }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Customer Contact Numbers</v-list-item-title>
                <v-list-item-subtitle>{{ sale.contact_numbers }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Total</v-list-item-title>
                <v-list-item-subtitle>{{
                  (sale.amount || '').toLocaleString()
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Sales discount</v-list-item-title>
                <v-list-item-subtitle v-if="!unsettled">{{
                  (sale.base_discount || '').toLocaleString()
                }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="unsettled">
                  <v-text-field
                    label="Discount"
                    v-model="editDiscount.base_discount"
                  ></v-text-field>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Discount</v-list-item-title>
                <v-list-item-subtitle>{{
                  (totalDiscount || '').toLocaleString()
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Net amount</v-list-item-title>
                <v-list-item-subtitle>{{
                  (netAmount || '').toLocaleString()
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Amount Receivable</v-list-item-title>
                <v-list-item-subtitle>{{
                  (sale.amount_receivable || '').toLocaleString()
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-simple-table fixed-header fixed-footer class="elevation-0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Serial</th>
                  <th class="text-left">Product</th>
                  <th class="text-left">Discount</th>
                  <th class="text-left">Price</th>
                  <th class="text-left">Net amount</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) of sale.inventories"
                  :key="item.id"
                  style="cursor: pointer"
                >
                  <td class="text-left">{{ item.serial }}</td>
                  <td class="text-left">
                    <span v-if="item.set_id != null">({{ item.set.name }})</span>
                    {{ item.product.name }}
                  </td>
                  <td v-if="!unsettled" class="text-left">{{ item.discount }}</td>
                  <td v-if="unsettled">
                    <v-text-field
                      label="Discount"
                      name="discount"
                      v-model="editDiscount.inventories[index].discount"
                    ></v-text-field>
                  </td>
                  <td class="text-left">{{ parseFloat(item.amount || '').toLocaleString() }}</td>
                  <td class="text-left">
                    {{ (item.amount - item.discount || '').toLocaleString() }}
                  </td>
                </tr>
                <tr v-if="sale.inventories.length == 0">
                  <td colspan="3" style="height:100px;text-align: center">
                    No records found
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="unsettled" outlined color="blue" @click="saveDiscount">
              Save discounts
            </v-btn>
            <v-btn v-if="unsettled" outlined color="green" @click="settle">
              Settle
            </v-btn>
            <v-btn @click="voidSale" outlined color="red">
              Void
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {
      editDiscount: {
        base_discount: '',
        inventories: []
      }
    };
  },
  components: {
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  beforeMount() {
    if (this.show) {
      this['Sale/getSale']({ id: this.$route.params.id }).finally(() => {
        if (this.sale.customer_name == '') {
          this.$router.push('/sale');
        }
      });
    }
  },
  watch: {
    sale(value) {
      this.editDiscount.base_discount = value.base_discount;
      this.editDiscount.inventories = value.inventories;
    }
  },
  computed: {
    ...mapState({
      sale(state) {
        if (typeof state.Sale.sale.data == 'undefined') {
          return {
            amount_receivable: '',
            amount: '',
            base_discount: 0,
            contact_numbers: '',
            customer_name: '',
            discount: '',
            inventories: [],
            net_amount: ''
          };
        } else {
          return {
            amount_receivable: state.Sale.sale.data.amount_receivable,
            amount: state.Sale.sale.data.amount,
            base_discount: state.Sale.sale.data.base_discount,
            contact_numbers: state.Sale.sale.data.customer.contact_numbers,
            customer_name: state.Sale.sale.data.customer.name,
            discount: state.Sale.sale.data.discount,
            inventories: state.Sale.sale.data.inventories,
            net_amount: state.Sale.sale.data.net_amount
          };
        }
      }
    }),
    totalDiscount() {
      return (
        parseFloat(this.editDiscount.base_discount) +
        this.editDiscount.inventories.reduce((a, b) => parseFloat(a) + parseFloat(b.discount), 0)
      );
    },
    netAmount() {
      return this.sale.amount - this.totalDiscount;
    },
    unsettled() {
      return this.sale.amount_receivable <= this.sale.amount;
    }
  },
  methods: {
    ...mapActions(['Sale/fetchSales', 'Sale/getSale']),
    settle() {
      axios
        .post(`api/v1/sale/${this.$route.params.id}/settle`)
        .then(response => {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Sale settled',
            color: 'success'
          });
          this['Sale/fetchSales']({ page: this.page });
          this['Sale/getSale']({ id: this.$route.params.id });
          // this.$router.push('/sale');
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {});
    },
    saveDiscount() {
      const discounts = {
        base_discount: this.editDiscount.base_discount,
        inventories: {}
      };

      this.editDiscount.inventories.forEach(function(inventory) {
        discounts.inventories[inventory.id] = inventory.discount;
      });

      axios
        .post(`api/v1/sale/${this.$route.params.id}/save_discount`, discounts)
        .then(response => {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Discount saved.',
            color: 'success'
          });
          this['Sale/fetchSales']({ page: this.page });
          this['Sale/getSale']({ id: this.$route.params.id });
          // this.$router.push('/sale');
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {});
    },
    voidSale() {
      this.$refs.confirm
        .open(
          'Void Sales',
          'Are you sure you want to void transaction for customer ' + this.sale.customer_name + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/sale/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Sale voided',
                color: 'success'
              });
              this['Sale/fetchSales']({ page: this.page });
              this.$router.push('/sale');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.errorMessages = error.response.data.errors;
              }
            })
            .finally(() => {});
        });
    }
  }
};
</script>
